// if (!window.Eurus.loadedScript.includes('product-cart.js')) {
//   window.Eurus.loadedScript.push('product-cart.js');

//   if (!window.Eurus.loadedScript.includes('product-cart.js')) {
//   window.Eurus.loadedScript.push('product-cart.js');

//   // ── Loop bundle: open the OCU drawer once the discounted add lands ──
//   function openOcuCartWhenAdded() {
//     function isOpen() {
//       var d = document.querySelector('.ocu-cart-drawer');
//       return d && d.classList.contains('ocu-visible');
//     }
//     function openCart() {
//       if (isOpen()) return;
//       var t = (document.getElementById('cart-icon-bubble') && document.getElementById('cart-icon-bubble').closest('a'))
//               || document.querySelector('a[href$="/cart"], a[href*="/cart"]');
//       if (t) t.click();
//       setTimeout(function () {
//         if (!isOpen()) {
//           var d = document.querySelector('.ocu-cart-drawer');
//           if (d) d.classList.add('ocu-visible'); // fallback if click didn't take
//         }
//       }, 400);
//     }
//     fetch('/cart.js', { headers: { Accept: 'application/json' } })
//       .then(function (r) { return r.json(); })
//       .then(function (c0) {
//         var before = c0.item_count, tries = 0;
//         var iv = setInterval(function () {
//           tries++;
//           fetch('/cart.js', { headers: { Accept: 'application/json' } })
//             .then(function (r) { return r.json(); })
//             .then(function (c) {
//               if (c.item_count !== before) { clearInterval(iv); setTimeout(openCart, 500); }
//               else if (tries > 15) clearInterval(iv);
//             }).catch(function () {});
//         }, 400);
//       }).catch(function () {});
//   }

//   requestAnimationFrame(() => {
//     document.addEventListener('alpine:init', () => {
//       // …Alpine.data('xProductCart', …) continues unchanged

//   requestAnimationFrame(() => {
//     document.addEventListener('alpine:init', () => {
//       Alpine.data('xProductCart', (
//         wrappringVariantId,
//         engravingVariantId,
//       ) => ({
//         loading: false,
//         errorMessage: false,
//         mainHasError: false,
//         buttonSubmit: "",
//         error_message_wrapper: {},
//         stopAction: false,
//         async addToCart(e, required, quickView) {
//           e.preventDefault();
//           async addToCart(e, required, quickView) {
//   e.preventDefault();

//   async addToCart(e, required, quickView) {
//           e.preventDefault();

//           // ── Loop preset-bundle guard ──────────────────────────────
//           try {
//             var form = (this.$el.closest && (this.$el.closest('form') || this.$el.closest('.product-info'))) || null;
//             var pidInput = form && form.querySelector('input[name="product-id"], input[name="product_id"]');
//             var pid = pidInput && pidInput.value;
//             if (pid && window.LOOP_WIDGET && window.LOOP_WIDGET[pid]) {
//               var bundleData = window.LOOP_WIDGET[pid].productBundleData;
//               if (bundleData && bundleData.variants && bundleData.variants.length) {
//                 bundleData.redirectionUrl = 'None';   // stop Loop's /cart redirect
//                 openOcuCartWhenAdded();                // open drawer once Loop's add lands
//                 return;                                // skip the theme's duplicate add
//               }
//             }
//           } catch (err) { /* fall through to normal add */ }
//           // ──────────────────────────────────────────────────────────

//           if (required) {
//             // …rest of the function continues unchanged
//           if (required) {
//             var productInfo = this.$el.closest('.product-info');
//             if (productInfo) {
//               var propertiesInput = productInfo.querySelectorAll(`.customization-picker`);
//               this.stopAction = false;
//               propertiesInput.length && propertiesInput.forEach((input) => {
//                 if (input.required && input.value.trim() == '' || input.classList.contains("validate-checkbox")) {
//                   input.classList.add("required-picker");
//                   this.stopAction = true;
//                 }
//               });
//             }
//             if (this.stopAction) {
//               return true;
//             }
//           }

//           this.loading = true;

//           if (this.$refs.engraving_text && engravingVariantId) {
//             if (this.$refs.engraving_text.value.trim()) {
//               if (!this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.setAttribute('name', this.$refs.text_area_name.value);
//             } else {
//               if (this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.removeAttribute('name');
//             }
//           }

//           var productForm = this.$el.closest('.product-info') || this.$el.closest('form');
//           var edt_element = productForm ? productForm.querySelector('.hidden.cart-edt-properties') : null;
//           if (edt_element) {
//             edt_element.value = edt_element.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti)
//           }

//           let formData = new FormData(this.$refs.product_form);
//           formData.append(
//             'sections',
//             Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
//           );
//           formData.append('sections_url', window.location.pathname);
//           await fetch(`${Eurus.cart_add_url}`, {
//             method:'POST',
//             headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
//             body: formData
//           }).then(reponse => {
//             return reponse.json();
//           }).then(async (response) => {
//             if (response.status == '422') {
//               if (typeof response.errors == 'object') {
//                 this.error_message_wrapper = response.errors;
//                 document.querySelector('.recipient-error-message').classList.remove('hidden');
//               } else {
//                 this.errorMessage = true;
//                 if(this.$refs.error_message){
//                   this.$refs.error_message.textContent = response.description;
//                 }
//                 if(this.$refs.error_message_mobile){
//                   this.$refs.error_message_mobile.textContent = response.description;
//                 }
//               }
//               if (Alpine.store('xMiniCart')) {
//                 Alpine.store('xMiniCart').reLoad();
//               }
//             } else {
//               if ((this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) || (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim())) {
//                 let additionalOptionData = {
//                   items: [],
//                   sections:  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
//                 };

//                 if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) {
//                   additionalOptionData.items.push(
//                     {
//                       id: wrappringVariantId,
//                       quantity: 1
//                     }
//                   );
//                 }
//                 if (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) {
//                   additionalOptionData.items.push(
//                     {
//                       id: engravingVariantId,
//                       quantity: 1
//                     }
//                   );
//                 }

//                 await window.fetch('/cart/add.js', {
//                   method: 'POST',
//                   credentials: 'same-origin',
//                   headers: {
//                     'Content-Type': 'application/json',
//                     'X-Requested-With': 'XMLHttpRequest'
//                   },
//                   body: JSON.stringify(additionalOptionData),
//                 }).then((response) => {
//                   return response.json();
//                 }).then(response => {
//                   document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
//                   this.error_message_wrapper = {};
    
                  
      
//                   if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
//                     Alpine.store('xQuickView').show = false;
//                   }
//                   Alpine.store('xPopup').close();
                  
//                     if((quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
//                       document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
//                     } else {
//                       Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
//                         const sectionElement = document.querySelector(section.selector);
//                         if (sectionElement) {
//                           if (response.sections[section.id])
//                             sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
//                         }
//                       }));
//                       setTimeout(() => {
//                         Alpine.store('xMiniCart').openCart();                  
//                       }, 500);
//                       Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
//                       document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
//                     }
//                 });
//               } else {
//                 document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
//                 this.error_message_wrapper = {};
  
                
    
//                 if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
//                   Alpine.store('xQuickView').show = false;
//                 }
//                 Alpine.store('xPopup').close();
                
//                 if((quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
//                   document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
//                 } else {
//                   Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
//                     const sectionElement = document.querySelector(section.selector);
//                     if (sectionElement) {
//                       if (response.sections[section.id])
//                         sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
//                     }
//                   }));
//                   Alpine.store('xMiniCart').openCart();                  
//                   Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
//                   document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
//                 }
//               }
//             }
//           }).catch((error) => {
//             console.error('Error:', error);
//           }).finally(() => {
//             this.loading = false;
//             if ((quickView && Alpine.store('xQuickView').buttonQuickView && !Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && !this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
//               if(this.$refs.gift_wrapping_checkbox) this.$refs.gift_wrapping_checkbox.checked = false;
//             }
//           }) 
//         }
//       }))
//     });
//   });
// }


if (!window.Eurus.loadedScript.includes('product-cart.js')) {
  window.Eurus.loadedScript.push('product-cart.js');

  // ── Loop bundle: open the OCU drawer once the discounted add lands ──
  function openOcuCartWhenAdded() {
    function isOpen() {
      var d = document.querySelector('.ocu-cart-drawer');
      return d && d.classList.contains('ocu-visible');
    }
    function openCart() {
      if (isOpen()) return;
      var s = window.Alpine && Alpine.store('xMiniCart');
      if (s && typeof s.openCart === 'function') {
        s.openCart();                 // AfterSell's own open → closeable
      } else {
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      }
    }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c0) {
        var before = c0.item_count, tries = 0;
        var iv = setInterval(function () {
          tries++;
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (c) {
              if (c.item_count !== before) { clearInterval(iv); setTimeout(function () { openCart(0); }, 500); }
              else if (tries > 15) clearInterval(iv); // give up after ~6s
            }).catch(function () {});
        }, 400);
      }).catch(function () {});
  }

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCart', (
        wrappringVariantId,
        engravingVariantId,
      ) => ({
        loading: false,
        errorMessage: false,
        mainHasError: false,
        buttonSubmit: "",
        error_message_wrapper: {},
        stopAction: false,
        async addToCart(e, required, quickView) {
          e.preventDefault();

          // ── Loop preset-bundle guard ──────────────────────────────
          // Loop clones the ATC button and attaches its own click handler
          // that does the discounted /cart/add.js. Alpine re-binds this
          // addToCart to the clone, so both fire. If this product is a Loop
          // preset bundle, let Loop handle the add and skip the theme's
          // plain /cart/add; also stop Loop's /cart redirect and open the
          // OCU drawer once the add lands.
          try {
            var lpForm = (this.$el.closest && (this.$el.closest('form') || this.$el.closest('.product-info'))) || null;
            var lpPidInput = lpForm && lpForm.querySelector('input[name="product-id"], input[name="product_id"]');
            var lpPid = lpPidInput && lpPidInput.value;
            if (lpPid && window.LOOP_WIDGET && window.LOOP_WIDGET[lpPid]) {
              var lpBundleData = window.LOOP_WIDGET[lpPid].productBundleData;
              if (lpBundleData && lpBundleData.variants && lpBundleData.variants.length) {
                lpBundleData.redirectionUrl = 'None';  // stop Loop's /cart redirect
                openOcuCartWhenAdded();                 // open drawer once Loop's add lands
                return;                                 // skip the theme's duplicate add
              }
            }
          } catch (err) { /* fall through to normal add */ }
          // ──────────────────────────────────────────────────────────

          if (required) {
            var productInfo = this.$el.closest('.product-info');
            if (productInfo) {
              var propertiesInput = productInfo.querySelectorAll(`.customization-picker`);
              this.stopAction = false;
              propertiesInput.length && propertiesInput.forEach((input) => {
                if (input.required && input.value.trim() == '' || input.classList.contains("validate-checkbox")) {
                  input.classList.add("required-picker");
                  this.stopAction = true;
                }
              });
            }
            if (this.stopAction) {
              return true;
            }
          }

          this.loading = true;

          if (this.$refs.engraving_text && engravingVariantId) {
            if (this.$refs.engraving_text.value.trim()) {
              if (!this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.setAttribute('name', this.$refs.text_area_name.value);
            } else {
              if (this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.removeAttribute('name');
            }
          }

          var productForm = this.$el.closest('.product-info') || this.$el.closest('form');
          var edt_element = productForm ? productForm.querySelector('.hidden.cart-edt-properties') : null;
          if (edt_element) {
            edt_element.value = edt_element.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti)
          }

          let formData = new FormData(this.$refs.product_form);
          formData.append(
            'sections',
            Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          await fetch(`${Eurus.cart_add_url}`, {
            method:'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          }).then(reponse => {
            return reponse.json();
          }).then(async (response) => {
            if (response.status == '422') {
              if (typeof response.errors == 'object') {
                this.error_message_wrapper = response.errors;
                document.querySelector('.recipient-error-message').classList.remove('hidden');
              } else {
                this.errorMessage = true;
                if(this.$refs.error_message){
                  this.$refs.error_message.textContent = response.description;
                }
                if(this.$refs.error_message_mobile){
                  this.$refs.error_message_mobile.textContent = response.description;
                }
              }
              if (Alpine.store('xMiniCart')) {
                Alpine.store('xMiniCart').reLoad();
              }
            } else {
              if ((this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) || (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim())) {
                let additionalOptionData = {
                  items: [],
                  sections:  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
                };

                if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) {
                  additionalOptionData.items.push(
                    {
                      id: wrappringVariantId,
                      quantity: 1
                    }
                  );
                }
                if (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) {
                  additionalOptionData.items.push(
                    {
                      id: engravingVariantId,
                      quantity: 1
                    }
                  );
                }

                await window.fetch('/cart/add.js', {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                  },
                  body: JSON.stringify(additionalOptionData),
                }).then((response) => {
                  return response.json();
                }).then(response => {
                  document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
                  this.error_message_wrapper = {};

                  if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                    Alpine.store('xQuickView').show = false;
                  }
                  Alpine.store('xPopup').close();

                    if((quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                      document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
                    } else {
                      Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
                        const sectionElement = document.querySelector(section.selector);
                        if (sectionElement) {
                          if (response.sections[section.id])
                            sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
                        }
                      }));
                      setTimeout(() => {
                        Alpine.store('xMiniCart').openCart();
                      }, 500);
                      Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
                      document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                    }
                });
              } else {
                document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
                this.error_message_wrapper = {};

                if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                  Alpine.store('xQuickView').show = false;
                }
                Alpine.store('xPopup').close();

                if((quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                  document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
                } else {
                  Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
                    const sectionElement = document.querySelector(section.selector);
                    if (sectionElement) {
                      if (response.sections[section.id])
                        sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
                    }
                  }));
                  Alpine.store('xMiniCart').openCart();
                  Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                }
              }
            }
          }).catch((error) => {
            console.error('Error:', error);
          }).finally(() => {
            this.loading = false;
            if ((quickView && Alpine.store('xQuickView').buttonQuickView && !Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && !this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
              if(this.$refs.gift_wrapping_checkbox) this.$refs.gift_wrapping_checkbox.checked = false;
            }
          })
        }
      }))
    });
  });
}